// angular
// 	.module("HeroPRO")
// 	.controller("OfficeFinancingController", officeFinancingController);


import _ from 'lodash';
import './officeFinancing.scss';

/* @ngInject */
export default function officeFinancingController(PlaidFactory, OfficesFactory, $stateParams, UserData, HPRoles, $q, raSpinnerService) {
    const vm = this;

    vm.heroDescription = 'Payments will be sent to the account information provided here.';

    // Flags
    vm.isEditingFinancing = false;
    vm.isImpersonation = false;
    vm.plaidValidation = {
        AccountOwnerNamesMatched: true,
        AccountAddressesMatched: true,
    };

    init();


    /*= =======================================
     =            Public Functions            =
     ======================================== */

    vm.editFinancing = function () {
        //vm.isEditingFinancing = true;

        UserData.getUserData()
            .then((userData) => {
                PlaidFactory
                    .createLinkToken(userData.ContractorUserId)
                    .then((response) => {
                        if (response.Data.LinkToken !== '') {
                            PlaidFactory
                                .openPlaid(response.Data.LinkToken)
                                .then((metadata) => {
                                    const publicToken = metadata.public_token;

                                    let selectedAccountId = null;
                                    if (metadata.account) {
                                        selectedAccountId = metadata.account.id;
                                    }

                                    if (!publicToken) {
                                        // TODO: Handle plaid error / not found
                                    } else {
                                        vm.loading = true;

                                        PlaidFactory
                                            .updateContractorLocationACH(Number($stateParams.accountId), publicToken, selectedAccountId)
                                            .then((achResponse) => {
                                                vm.plaidValidation = achResponse.data.Data;
                                                init();
                                            }, (err) => {
                                                throw err;
                                            });
                                    }
                                }, (err) => {
                                    throw err;
                                });
                        }
                    }, (err) => {
                        throw err;
                    });
            });
    };

    // Function used to add additional behavior to Cancel button in Edit ACH Directive
    vm.cancelEditFinancing = function () {
        vm.isEditingFinancing = false;
    };

    // Function used to add additional behavior to Save button in Edit ACH Directive
    vm.saveFinancingUpdate = function () {
        vm.isEditingFinancing = false;
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
     =            Private Functions            =
     ======================================== */
    function init() {
        vm.loading = true;
        getOfficeProfile().then(() => {
            vm.loading = false;
        });
    }

    function getOfficeProfile() {
        return $q((resolve, reject) => {
            const data = {
                ContractorLocationId: Number($stateParams.accountId),
            };
            UserData.getUserData().then((response) => {
                const currentRole = _.find(HPRoles, (key, other) => other === response.Roles[0]);
                vm.isImpersonation = !!response.ImpersonatorName;

                data.IncludeACHInfo = currentRole.isAdmin;
                OfficesFactory.getOfficeProfile(data).then((response) => {
                    vm.financeInfo = response.data.PaymentDetail;
                    getPaymentStatuses().then(() => {
                        resolve();
                    });
                });
            });
        });
    }

    function getPaymentStatuses() {
        return $q((resolve, reject) => {
            OfficesFactory.getPaymentStatuses().then((response) => {
                vm.paymentStatuses = response;
                _.each(vm.paymentStatuses, (status) => {
                    if (status.PaymentMethodStatusId === vm.financeInfo.PaymentMethodStatusId) {
                        vm.financeInfo.currentStatusMessage = status.Description;
                    }
                });
                resolve();
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/financing/officeFinancingController.js